import styled from '@emotion/styled';
import { AlertBanner, AlertsIcon, Css, Responsive } from '../../ui';

interface IAlertBanners {
	title: string;
	body: string;
	link?: string;
}

export function AlertBanners({ title, body, link }: IAlertBanners) {
	return (
		<AlertBanner
			fullyClickable={!!link}
			title={title}
			url={link}
			alertIcon={<AlertsIcon aria-label="Alert" />}
		>
			<AlertBodyWrap>
				<AlertBannerBody aria-label={body}>{body}</AlertBannerBody>
			</AlertBodyWrap>
		</AlertBanner>
	);
}

const AlertBodyWrap = styled.div`
	gap: ${Css.pxToRem(8)};
	line-height: ${Css.pxToRem(22)};
	flex-direction: column;
	font-weight: 500;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		flex-direction: column;

		a {
			padding: 0;
		}
	}
`;

const AlertBannerBody = styled.div`
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	font-weight: 300;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-left: 0;
	}
`;
